import React, { useState } from 'react';
import { message, Button } from 'antd';
import { FileDoneOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import useAuthContext from '../../contexts/AuthContext';
import { useStateWithLocalStorage } from '../../utils';

const Universign = ({ insurer }) => {
  const [loading, setLoading] = useState(false);
  const { dispatchAPI } = useAuthContext();
  const [loadingText, setLoadingText] = useState(
    'Signer électroniquement ma convention de courtage'
  );
  const [, setDocumentId] = useStateWithLocalStorage('documentId', false);

  const id_user = insurer && insurer._id;

  // Make the user actually sign the document
  const sign = async (user_id, app_url, is_insurer) => {
    const { data } = await dispatchAPI('POST', {
      url: '/universign/',
      body: { id: user_id, app_url, is_insurer }
    });
    return data;
  };

  const makeUserSign = async (is_insurer = true, user = id_user) => {
    setLoading(true);
    setLoadingText('Veuillez patienter');
    const redirection_url = `${window.location.protocol}//${window.location.host}`;
    const data = await sign(user, redirection_url, is_insurer);
    setLoading(false);
    setLoadingText('Signer le document');
    message.success('Vous allez être redirigé vers Universign un moment...');
    setDocumentId(data.id);
    window.location.replace(data.url);
  };

  return (
    <Button
      type="primary"
      loading={loading}
      onClick={() => makeUserSign()}
      icon={<FileDoneOutlined />}
    >
      <span style={{ marginLeft: '8px' }}>{loadingText}</span>
    </Button>
  );
};

Universign.propTypes = {
  insurer: PropTypes.object.isRequired
};

export default Universign;
